module.exports = __webpack_public_path__ + "static/media/rotate-icon.88e4b347.png";